/* ==========================================================================
   SearcherFerryHotelRxjs > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'SearcherFerryHotelRxjs',
    init: true,
    events: true,
    start: true,
    type: {
        origin: 'searcher-ferry-hotel-origin',
        destination: 'searcher-ferry-hotel-destination',
        calendar: 'searcher-ferry-hotel-calendar',
        calendarInput: 'searcher-ferry-hotel-calendar-input',
        accommodation: 'searcher-ferry-hotel-accomodation',
        vehicleInput: 'searcher-ferry-hotel-vehicle-input',
        vehicle: 'searcher-ferry-hotel-vehicle',
        vehicles: 'searcher-ferry-hotel-vehicle-options',
        trailer: 'searcher-ferry-hotel-vehicle-trailer',
        dimensions: 'searcher-ferry-hotel-vehicle-dimensions',
        discount: 'searcher-ferry-hotel-discount',
        bonus: 'searcher-ferry-hotel-bonus',
        loading: 'searcher-ferry-hotel-loading',
        submit: 'searcher-ferry-hotel-submit',
        addRoom: 'searcher-ferry-hotel-add-rom'
    },
    hooks: {
        panelContent: 'data-searcher-ferry-hotel-panel-content',
        panelBody: 'data-searcher-ferry-hotel-panel-body',
        vehicleDimensions: 'data-vehicle-dimensions',
        trailerDimensions: 'data-trailer-dimensions'
    },
    icons: {
        calendar: 'calendar'
    },
    css: {
        item: 'searcher__item',
        itemLong: 'searcher__item--long',
        calendar: 'input-panel--calendar-sfh',
        calendarPanel: 'input-panel__panel--calendar-sfh',
        calendarFp: 'calendar-rxjs--single',
        accommodation: 'input-panel--accommodation-sfh',
        accommodationPanel: 'input-panel__panel--accommodation-sfh',
        vehicle: 'input-panel--vehicle-sfh',
        vehiclePanel: 'input-panel__panel--vehicle-sfh',
        submit: 'searcher__button',
        loading: 'loading-information-rxjs--sfh'
    },
    onModal: false,
    showLoading: true,
    select: {
        choices: {
            searchEnabled: false
        }
    }
};

module.exports = () => config;
